import { render } from "./G2AAgreement.vue?vue&type=template&id=30a1d415&scoped=true"
import script from "./G2AAgreement.vue?vue&type=script&lang=js"
export * from "./G2AAgreement.vue?vue&type=script&lang=js"

import "./G2AAgreement.vue?vue&type=style&index=0&id=30a1d415&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Lineage-2-Vue-JS-3-Frontend/Lineage-2-Vue-JS-3-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a1d415"]])

export default __exports__